import { Component, OnInit } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { PoBreadcrumb, PoTableColumnSpacing } from '@po-ui/ng-components';
import { PoPageDynamicEditActions, PoPageDynamicEditField } from '@po-ui/ng-templates';
import { SchemaBuilderService } from '../../../core/menu/schema-builder.service';

@Component({
  selector: 'app-codigos-internos-edit',
  templateUrl: './codigos-internos-edit.component.html',
  styleUrls: ['./codigos-internos-edit.component.css'],
  standalone: false
})
export class CodigosInternosEditComponent implements OnInit {

  readonly serviceApi = `${environment.apiUrl}${environment.versionApi}/codigos-internos`;

  public readonly breadcrumb: PoBreadcrumb = {
      items: [{ label: 'Home', link: '/' }, { label: 'Códigos Internos', link: '/codigos-internos' }, { label: 'Edição Códigos Internos' }]
  };

  public readonly actions: PoPageDynamicEditActions = {
      save: 'codigos-internos',
  };

  fields: PoPageDynamicEditField[] = [];
  poTableColumnSpacing: PoTableColumnSpacing = PoTableColumnSpacing.Small;

  constructor(private readonly schemaBuilderService: SchemaBuilderService) { }

  ngOnInit(): void {
    this.schemaBuilderService.getFieldSchema('codigos-internos').subscribe(data => {
        this.fields = data;
    });
  }
}
